import React, { useEffect, useState } from "react";
import { useDrag } from "react-dnd";
import { ItemSubtypes, ItemTypes } from "../../../DnDTypes";
import "rc-time-picker/assets/index.css";
import TimeField from "react-simple-timefield";
import * as classnames from "classnames";
import s from "./index.module.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";

// dragaMode = either 'clone' or 'move'

const TimeControl = ({
  name,
  id,
  disabled,
  isSelected = false,
  dragMode = "move",
  configuration = {},
  markSelected,
  onChange,
  showSelfDescription,
  sidebarMode,
  formCreatorMode,
  removable,
  onRemove,
  rowIndex,
  index,
  setIsDragging,
  filledValue,
  filledFormMode,
}) => {
  const [, drag] = useDrag({
    item: {
      type: ItemTypes.COMPONENT,
      subtype: ItemSubtypes.TIME,
      dragMode,
      defaultLabel: "Czas",
      id,
      rowIndex,
      index,
    },
    collect: (monitor, props) => {
      setIsDragging && setIsDragging(!!monitor.isDragging());

      return {
        isDragging: !!monitor.isDragging(),
      };
    },
    canDrag: () => {
      return dragMode === "move" || dragMode === "clone";
    },
  });

  const [value, setValue] = useState(filledValue || "");
  useEffect(() => {
    setValue(filledValue);
  }, filledValue);

  const clicked = () =>
    markSelected &&
    markSelected({
      id,
      configuration,
    });

  const onTimeChange = (event, value) => {
    const newTime = value.replace(/-/g, ":");
    const time = newTime.substr(0, 5);

    setValue(value);
    if (onChange) {
      onChange({
        id,
        value: time,
      });
    }
  };

  const updateValue = (value) => {
    setValue(value);

    const s = moment(value).format("HH:mm");

    if (onChange) {
      onChange({
        id,
        value: s,
      });
    }
  };

  if (sidebarMode) {
    return (
      <div ref={drag}>
        <input
          readOnly={true}
          type="text"
          className="input"
          placeholder="Czas"
        />
      </div>
    );
  }

  const placeholder = showSelfDescription
    ? "Czas"
    : (configuration && configuration.text) || "";
  const label = (configuration && configuration.label) || "";

  if (formCreatorMode) {
    return (
      <div ref={drag}>
        {label && <label className={classnames("label")}>{label}</label>}
        {!label && (
          <label
            dangerouslySetInnerHTML={{ __html: "&nbsp;" }}
            className={classnames("label")}
          ></label>
        )}
        <div ref={drag} className={s.relative}>
          <input
            placeholder={placeholder}
            className={classnames("input", {
              [s.hasActiveConfiguration]: isSelected,
            })}
            name={name}
            id={id}
            onClick={clicked}
            readOnly
          />
          <FontAwesomeIcon
            className={classnames(s.trashIcon, "has-text-grey")}
            onClick={onRemove}
            icon="trash"
            title="Usuń"
          />
        </div>
      </div>
    );
  }
  if (filledFormMode) {
    return (
      <div>
        {label && <label className={classnames("label")}>{label}</label>}
        {!label && (
          <label
            dangerouslySetInnerHTML={{ __html: "&nbsp;" }}
            className={classnames("label")}
          ></label>
        )}

        <input
          disabled={disabled}
          type="text"
          className={classnames("input")}
          name={name}
          id={id}
          value={value}
        />
      </div>
    );
  }

  const pickerProps = {
    ...(value ? { value } : {}),
  };

  return (
    <div>
      {label && <label className={classnames("label")}>{label}</label>}
      {!label && (
        <label
          dangerouslySetInnerHTML={{ __html: "&nbsp;" }}
          className={classnames("label")}
        ></label>
      )}

      <TimeField
        style={{
          border: "2px solid #666",
          fontSize: 15,
          width: 60,
          padding: "5px 8px",
          color: "#333",
          borderRadius: 3,
        }}
        onChange={onTimeChange}
        placeholder={placeholder}
        disabled={disabled}
        className="input"
        name={name}
        id={id}
        onClick={clicked}
        inputReadOnly
        {...pickerProps}
      />
    </div>
  );
};

export default TimeControl;
